import { render, staticRenderFns } from "./ReleaseConceptContributors.vue?vue&type=template&id=1fec935a&"
import script from "./ReleaseConceptContributors.vue?vue&type=script&lang=js&"
export * from "./ReleaseConceptContributors.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseConceptContributors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports